import { useEffect } from "react";
import { toast } from "react-toastify";

import { useScreenshotContext } from "./useScreenshotContext";

/**
 * A custom hook that dismisses all toast notifications when screenshot mode is activated.
 * This prevents toasts from appearing in the screenshot window, ensuring clean visual output.
 *
 * @remarks
 * This hook depends on the `useScreenshotContext` hook to determine when screenshot mode is active.
 * When a screenshot is activated (widget property is set), all active toasts are dismissed.
 * When screenshot is deactivated or on unmount, no additional action is taken.
 *
 * @returns void
 */
export const useToastScreenshotControl = () => {
  const { widget } = useScreenshotContext();
  const screenshotActive = !!widget;

  useEffect(() => {
    if (screenshotActive) {
      // Dismiss all active toasts when entering screenshot mode
      toast.dismiss();
    }
  }, [screenshotActive]);
};
